// removed by extract-text-webpack-plugin
module.exports = {"button":"_3Yr7OU7lYwtJ4XkafMUJxf","buttonLightTheme":"g6dH0aHQZZnDjPYTd-A_W","buttonDarkTheme":"_3-R0Rk9A0LVzylLqReIJy1","buttonIsDisabeld":"_1Iz9ChzLRGMVu3TiclPwBl","label":"_1oXNlAVn6wW9_81qMYGjeQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/styles.css
// module id = 311
// module chunks = 0